import { generateUUID } from "@/utils/UUIDHelper";

const SESSION_KEY = "SCRM_SESSION_ID";

/**
 * Initializes the session ID in sessionStorage if it doesn't exist.
 * This ensures the ID persists through page refreshes but clears on tab close.
 */
export const initSession = (): void => {
  if (typeof window !== "undefined" && !sessionStorage.getItem(SESSION_KEY)) {
    const newSessionId = generateUUID();
    sessionStorage.setItem(SESSION_KEY, newSessionId);
  }
};

/**
 * Helper to retrieve the current session ID for logging or API calls.
 */
export const getSessionId = (): string | null => {
  return sessionStorage.getItem(SESSION_KEY);
};
